import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
}

const ScrollToTop = () => {
    const { pathname, search } = useLocation()

    useEffect(() => {
        scrollToTop()
    }, [pathname, search])

    return null
}

export default ScrollToTop
